import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { getTheme } from './theme';
/**
 * A context provider that enables a theme to be consumed by its children
 *
 * This component should wrap the top level of your app to ensure that all descendent components can access the theme properties.
 */
export const AwazeThemeProvider = ({ children, brand = 'agnostic', }) => {
    return _jsx(ThemeProvider, { theme: getTheme(brand), children: children });
};
//# sourceMappingURL=awaze-theme-provider-context-provider.js.map